import styled from "styled-components";
import { device } from "../../styles/devices";

import profilePhoto from '../../assets/profile.png';

export const ProfileImage = styled.div`
    background-image: url(${profilePhoto});
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    box-shadow: inset 0 0 0 9px rgb(255 255 255/30%);
    width: 400px;
    height: 400px;
    justify-self: center;
    animation: profile_animate 2.5s ease-in-out infinite 1s;
    border-radius: 60% 40% 30% 70%/60% 30% 70% 40%;

    @media ${device.tabletLarge}{
        width: 320px;
        height: 320px;
    }

    @media ${device.tablet}{
        order: 0;
        justify-self: initial;

        width: 280px;
        height: 280px;
    }

    @media ${device.mobile}{
        width: 240px;
        height: 240px;
    }

    @keyframes profile_animate {
       0%{
        border-radius: 60% 40% 30% 70%/60% 30% 70% 40%;
       } 
       50%{
        border-radius: 30% 60% 70% 40%/50% 60% 30% 60%;
       } 
       100%{
        border-radius: 60% 40% 30% 70%/60% 30% 70% 40%;
       } 
    }
`;